export class EnumApiBffsvr {
    constructor() {
        /**
         * @dec 登陆
         * @method post
         * @params loginType password userName  validationCode
         */
        this.bffsvr_login = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/login/mobile',
            method: 'post',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec token 获取用户信息
         */
        this.bffsvr_user = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/getUserCenterInfo',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec token 获取用户信息
         */
        this.bffsvr_user_token = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/token',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 图片验证码
         */
        this.bffsvr_imgCode = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/imgCode',
            method: 'post',
            awaitAuthenticated: false,
        };
        /**
         * @dec 发送短信验证码
         * @params imgCode imgSession mobilePhone sendType
         */
        this.bffsvr_SendCode = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/user/sendValidationCode',
            method: 'post',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 个人中心-更改基本信息
         */
        this.bffsvr_updateUserCenterInfo = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/updateUserCenterInfo',
            method: 'put',
            loading: true,
        };
        /**
         * @dec 个人中心-更改图像
         */
        this.bffsvr_updateAvatar = {
            // url: `/fos/tools/file/share/upload`,
            url: `api/bpportal/pcsd-bp-fos-entrance/tools/file/share/upload/`,
            method: 'post',
            loading: true,
        };
        /**
         * @dec 个人中心-更改地址信息
         */
        this.bffsvr_updateUserExtend = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/updateUserExtend',
            method: 'put',
            loading: true,
        };
        /**
         * @dec 个人中心-获取k码
         */
        this.bffsvr_getResellerByTax = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/getResellerByTax',
            method: 'get',
        };
        /**
         * @dec 个人中心-k码登陆-绑定手机号
         */
        this.bffsvr_k2mobile = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/bind/k2mobile',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 个人中心-手机号登陆-绑定k码
         */
        this.bffsvr_mobile2k = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/bind/mobile2k',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 企业认证 - token 获取企业认证信息
         */
        this.bffsvr_auth_token = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/token',
            loading: true,
            // cache:true,
        };
        /**
         * @dec 企业认证 - 营业执照识别
         */
        this.bffsvr_auth_ocrBusLicense = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/ocr/busLicense',
            loading: true,
        };
        /**
         * @dec 企业认证 - 身份证识别
         */
        this.bffsvr_auth_idCard = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/ocr/idCard/front',
            loading: true,
        };
        /**
         * @dec 企业认证 - 提交认证
         */
        this.bffsvr_auth_submit = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/userVerified/certification',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 地址列表
         * @params
         */
        this.bffsvr_address = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/findList',
            method: 'post',
            // cache: true,
            loading: true,
        };
        /**
         * @dec 地址详情
         * @params
         */
        this.bffsvr_address_details = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/{id}',
            loading: true,
        };
        /**
         * @dec 地址添加
         * @params
         */
        this.bffsvr_address_add = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/add',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 地址修改
         * @params
         */
        this.bffsvr_address_update = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/update',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 地址删除
         * @params
         */
        this.bffsvr_address_delete = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/address/delete',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 积分查询 总体
         * @params
         */
        this.bffsvr_integral_total = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/integral/token',
            loading: true,
        };
        /**
         * @dec 积分查询 列表
         * @params
         */
        this.bffsvr_integral_list = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/integral/list/token',
            method: 'post',
            loading: true,
        };
        /**
         * @dec sales 我的二维码
         * @params
         */
        this.bffsvr_poster_list = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/promotion/poster',
            loading: true,
        };
        /**
         * @dec sales 我的邀请客户
         * @params
         */
        this.bffsvr_invitationPage_list = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/token/promo/invitation',
            method: 'post',
            loading: true,
        };
        /**
         * @dec sales 我的区域客户
         * @params
         */
        this.bffsvr_regionPage_list = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/token/region',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 注册时候验证手机号是否存在
         */
        this.bffsvr_existMobile = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/checkUserExist/{usercode}',
        };
        /**
         * @dec 注册账号
         */
        this.bffsvr_register = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/register',
            method: 'post',
            loading: true,
        };
        /**
         * @dec 找回密码
         */
        this.bffsvr_retrievePwd = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v2/user/retrievePwd',
            method: 'put',
            loading: true,
        };
        /**
         * @dec 修改密码
         */
        this.bffsvr_updatePwd = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/user/updatePwd',
            method: 'put',
            loading: true,
        };
        /**
         * @dec token 直播间获取用户信息
         */
        this.bffsvr_company_token = {
            url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/WorkbenchCockpit/companyInfo?cityCode={cityCode}',
            method: 'get',
        };
    }
}
